<div class="container-mfa">
  <h1 class="title">{{'MFA' | translate}}</h1>

  <div class="form-card">
    <h2 *ngIf="!mfaVerified && !mfaAlreadyConfigured" class="text-center subtitle">
      {{'MFA_CONFIGURE_HEADING' | translate}}
    </h2>
    <h2 *ngIf="mfaVerified || mfaAlreadyConfigured" class="text-center subtitle">
     {{'MFA_ACTIVATED_HEADING' | translate}}
    </h2>
    <p class="text-center" *ngIf="!mfaVerified && !mfaAlreadyConfigured">
      {{'MFA_SCAN_INSTRUCTION' | translate}}
    </p>
    <div class="qr-code-container">
      <ng-container *ngIf="!mfaVerified && !mfaAlreadyConfigured; else verifiedBlock">
        <ng-container *ngIf="loading; else codeForm">
          <div class="loading">
            <div class="spinner-border" role="status"></div>
          </div>
        </ng-container>
        <ng-template #codeForm>
          <form (ngSubmit)="verifyCode()" class="d-flex flex-column align-items-center">
            <img [src]="qrCodeImage"alt="QR para autenticación" class="qr-image mb-4"/>
            <div class="form-group form-floating w-100 text-center">
              <input type="text" class="form-control text-center" id="code"
                name="verificationCode" [(ngModel)]="verificationCode" placeholder="Ej. 123456" required/>
              <label for="code">{{'MFA_ENTER_CODE_LABEL' | translate}}</label>
            </div>
            <button class="primary-btn mt-3" type="submit">
              {{'MFA_VERIFY_BUTTON' | translate}}
            </button>
          </form>
        </ng-template>
      </ng-container>
      <ng-template #verifiedBlock>
        <div class="qr-success-feedback text-center">
          <div class="d-flex flex-column align-items-center" *ngIf="mfaAlreadyConfigured">
            <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 48 48">
              <path fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" d="M24 43.5c9.043-3.117 15.489-10.363 16.5-19.589c.28-4.005.257-8.025-.071-12.027a2.54 2.54 0 0 0-2.468-2.366c-4.091-.126-8.846-.808-12.52-4.427a2.05 2.05 0 0 0-2.881 0c-3.675 3.619-8.43 4.301-12.52 4.427a2.54 2.54 0 0 0-2.468 2.366A79.4 79.4 0 0 0 7.5 23.911C8.512 33.137 14.957 40.383 24 43.5"/><path fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" d="M17.612 19.804h12.776c.484 0 .877.392.877.877v9.442a.877.877 0 0 1-.877.877H17.612a.877.877 0 0 1-.877-.877V20.68c0-.485.393-.878.877-.878"/><path fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" d="M19.192 19.804V17.79a4.805 4.805 0 0 1 9.608 0v2.014"/><circle cx="23.996" cy="25.402" r="1.863" fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <p class="text-muted mt-2">
           {{'MFA_SUCCESS_MESSAGE' | translate}}
          </p>
        </div>
      </ng-template>
        <button class="remove-btn mt-3" *ngIf="mfaAlreadyConfigured" (click)="mfaModalDelete = true">
          {{'MFA_DEACTIVATE_BUTTON' | translate}}
        </button>
    </div>
    <p class="text-center text-danger mt-3" *ngIf="errorEmptyCodeMessage">
      {{'MFA_EMPTY_CODE' | translate}}
    </p>
    <p class="text-center text-danger mt-3" *ngIf="errorInvalidCodeMessage">
      {{'MFA_INVALID_CODE' | translate}}
    </p>
  </div>
</div>
<!-- MODAL DE CONFIRMACIÓN PARA ELIMINAR MFA -->
<app-confirmation-modal
  *ngIf="mfaModalDelete"
  [title]="'MFA_DELETE_CONFIRM_TITLE' | translate"
  [message]="'MFA_DELETE_CONFIRM_MESSAGE' | translate"
  [confirmText]="'DELETE' | translate"
  [cancelText]="'CANCEL' | translate"
  (response)="onDeleteConfirm($event)">
</app-confirmation-modal>


<div class="modal mfa-confirm-modal" id="mfaDeletedModal" tabindex="-1">
  <div class="modal-dialog mfa-modal-dialog" role="document">
    <div class="modal-content mfa-modal-content">
      <div class="modal-body mfa-modal-body">
        <h3 class="text-center">{{'MFA_DELETED_TITLE' | translate}}</h3>
        <p class="text-center">{{'MFA_DELETED_MESSAGE' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">
          {{'CLOSE' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal mfa-confirm-modal" id="mfaConfiguredModal" tabindex="-1">
  <div class="modal-dialog mfa-modal-dialog" role="document">
    <div class="modal-content mfa-modal-content">
      <div class="modal-body mfa-modal-body">
        <div class="success-check-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none"
               stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="14 26 22 34 38 18" />
          </svg>
        </div>
        <h3 class="text-center">{{'MFA_CONFIGURED_TITLE' | translate}}</h3>
        <p class="text-center">{{'MFA_CONFIGURED_MESSAGE' | translate}}</p>
      </div>
    </div>
  </div>
</div>

<div class="modal mfa-confirm-modal" id="mfaErrorDeletedModal" tabindex="-1">
  <div class="modal-dialog mfa-modal-dialog" role="document">
    <div class="modal-content mfa-modal-content">
      <div class="modal-body mfa-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'MFA_ERROR_DELETE' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">
          {{'CLOSE' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>